module.exports = __webpack_public_path__ + "img/cart.b03778ca.svg";